module.exports = __webpack_public_path__ + "static/img/logo_bc.898f7c65.jpg";